var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAgencyQoushan({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100.001,
    height: 100.001,
    viewBox: "0 0 100.001 100.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Real_estate_-_Free_real_estate_icons-2",
    "data-name": "Real estate - Free real estate icons-2",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10068",
    "data-name": "Group 10068",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10067",
    "data-name": "Group 10067",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10066",
    "data-name": "Group 10066"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9897",
    "data-name": "Path 9897",
    d: "M407.537,341.337A1.666,1.666,0,0,0,405.87,343v28.334H394.2a1.667,1.667,0,0,0,0,3.333h13.333A1.666,1.666,0,0,0,409.2,373V343A1.667,1.667,0,0,0,407.537,341.337Z",
    transform: "translate(-315.869 -274.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9898",
    "data-name": "Path 9898",
    d: "M388.8,356.337V343a1.666,1.666,0,0,0-1.667-1.667h-10A1.666,1.666,0,0,0,375.469,343v13.333A1.666,1.666,0,0,0,377.136,358h10A1.666,1.666,0,0,0,388.8,356.337Zm-3.333-1.667H378.8v-10h6.667Z",
    transform: "translate(-302.135 -274.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9899",
    "data-name": "Path 9899",
    d: "M119.936,97a1.666,1.666,0,0,0,1.667-1.667V87a1.666,1.666,0,0,0-1.667-1.667h-50A1.666,1.666,0,0,0,68.269,87v58.334a1.667,1.667,0,0,0,3.333,0V142h1.667a1.667,1.667,0,0,0,0-3.333H71.6v-10h6.667v6.667a1.667,1.667,0,0,0,3.333,0v-6.667h6.667A1.666,1.666,0,0,0,89.935,127a1.666,1.666,0,0,0,1.667-1.667v-10h6.667a1.667,1.667,0,0,0,3.333,0,1.667,1.667,0,0,0,0-3.333V102h6.667v3.333a1.667,1.667,0,0,0,3.333,0V102h3.333a1.667,1.667,0,0,0,0-3.333H111.6v-10h6.667v6.667A1.668,1.668,0,0,0,119.936,97ZM78.269,125.337H71.6v-10h6.667v10Zm0-13.333H71.6V102h6.667v10Zm0-13.333H71.6v-10h6.667v10Zm10,26.667H81.6v-10h6.667Zm0-13.333H81.6V102h6.667Zm0-13.333H81.6v-10h6.667Zm10,13.333H91.6V102h6.667Zm0-13.333H91.6v-10h6.667Zm10,0H101.6v-10h6.667Z",
    transform: "translate(-54.935 -68.67)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9900",
    "data-name": "Path 9900",
    d: "M35.8,85a1.666,1.666,0,0,0,1.667-1.667v-70H49.136A1.666,1.666,0,0,0,50.8,11.671v-5H62.469A1.666,1.666,0,0,0,64.136,5V3.337H70.8V5A1.666,1.666,0,0,0,72.469,6.67H84.136V10H55.8a1.667,1.667,0,1,0,0,3.333H97.47V20a1.667,1.667,0,1,0,3.333,0V11.671A1.666,1.666,0,0,0,99.136,10H87.469V5A1.666,1.666,0,0,0,85.8,3.337H74.136V1.671A1.666,1.666,0,0,0,72.47,0h-10A1.666,1.666,0,0,0,60.8,1.671V3.337H49.136A1.666,1.666,0,0,0,47.47,5v5H35.8a1.666,1.666,0,0,0-1.667,1.667V83.338A1.666,1.666,0,0,0,35.8,85Z",
    transform: "translate(-27.469 -0.003)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9901",
    "data-name": "Path 9901",
    d: "M379.868,174H368.2v-1.667a1.666,1.666,0,0,0-1.667-1.667h-6.667a1.666,1.666,0,0,0-1.667,1.667v3.333a1.667,1.667,0,1,0,3.333,0V174h3.333v1.667a1.666,1.666,0,0,0,1.667,1.667H378.2v22.643l-25.488-25.488a1.666,1.666,0,0,0-2.357,2.357l28.333,28.333A1.666,1.666,0,0,0,381.534,204V175.671A1.666,1.666,0,0,0,379.868,174Z",
    transform: "translate(-281.533 -137.337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9902",
    "data-name": "Path 9902",
    d: "M209,388.6H192.337a1.666,1.666,0,0,0-1.667,1.667v1.667H174V368.6a1.667,1.667,0,0,0-3.333,0v25a1.666,1.666,0,0,0,1.667,1.667h20A1.666,1.666,0,0,0,194,393.6v-1.667h13.333V393.6a1.667,1.667,0,0,0,3.333,0V390.27A1.666,1.666,0,0,0,209,388.6Z",
    transform: "translate(-137.336 -295.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9903",
    "data-name": "Path 9903",
    d: "M99.513.49a1.665,1.665,0,0,0-2.357,0L.489,97.157a1.666,1.666,0,1,0,2.357,2.357L99.513,2.847A1.665,1.665,0,0,0,99.513.49Z",
    transform: "translate(0 -0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9904",
    "data-name": "Path 9904",
    d: "M301.8,364.67A1.666,1.666,0,0,0,303.469,363V343a1.666,1.666,0,0,0-1.667-1.667h-10A1.666,1.666,0,0,0,290.136,343v20a1.667,1.667,0,0,0,3.333,0V344.67h6.667v6.667h-1.667a1.667,1.667,0,1,0,0,3.333h1.667V363A1.667,1.667,0,0,0,301.8,364.67Z",
    transform: "translate(-233.468 -274.669)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9905",
    "data-name": "Path 9905",
    d: "M206.47,341.337A1.666,1.666,0,0,0,204.8,343v13.333A1.666,1.666,0,0,0,206.47,358h10a1.666,1.666,0,0,0,1.667-1.667V343a1.666,1.666,0,0,0-1.667-1.667ZM214.8,354.67h-6.667v-10H214.8Z",
    transform: "translate(-164.802 -274.669)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgencyQoushan);
export default __webpack_public_path__ + "static/media/agencyQoushan.0177017684bfc8c64c436d3e3ab6039e.svg";
export { ForwardRef as ReactComponent };